export default __webpack_public_path__ + "static/media/pullOver.aba3d046.svg";